import styled from 'styled-components';
import Owner from './component';

export default styled(Owner)`
  color: var(--primary500);
  max-width: 93px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .selected {
    color: var(--primary900);
  }

  .open {
    color: var(--primary900);
  }

  .item {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;
